var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(0 5)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.146 3.144L1.147 7.145a.5.5 0 00-.058.638l.058.07 4 4a.5.5 0 00.764-.638l-.057-.07-3.646-3.647L5.853 3.85a.5.5 0 00.058-.637l-.058-.07a.5.5 0 00-.638-.057l-.07.058z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 7a.5.5 0 01.09.992L23.5 8h-22a.5.5 0 01-.09-.992L1.5 7h22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 14,
    rx: 0.5
  }))));
}
export default SvgFiltersHide;